var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFisicaDeselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.64 330.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eb4548;\n      }\n\n      .cls-2 {\n        fill: #8486c0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raccolta"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.04,234.8l-21.19-52.42,17.85,1.12c3.65,16.03,8.64,32.09,13.62,47.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.9,322.41c-14.47,12.72-39.44,10.58-51.54-4.42-5.04-6.25-7.83-14-10.2-21.67-3.9-12.64-6.93-25.87-5.44-39.01,1.49-13.14,8.18-26.28,19.76-32.67,11.58-6.38,28.14-4,35.37,7.08,7.26-6.99,16.28-14.38,25.72-17.9s21.17-2.78,28.23,4.41c2.67,2.72,4.51,6.14,6,9.65,9.8,23.1,5.46,49.52.09,74.04-1.13,5.17-2.4,10.54-5.73,14.65-2.75,3.39-6.68,5.62-10.75,7.2-10.86,4.23-20.67,2.93-31.51-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.56,198.89l3.66-113.45c-5.42.16-11.74.51-17.17.51l1.81,112.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.56 138.67 31.56 44 47.11 44.44 43.11 144.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.33 77.33 72 76.89 72 180.44 80 181.78 85.33 77.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.22 189.99 120.89 53.03 107.11 51.56 104.89 192.44 114.22 189.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.89 60.44 86.67 38.22 72.89 36 73.33 60.89 84.89 60.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "120 42.67 120.89 12.89 109.33 11.11 108.44 36 120 42.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.67 28.89 49.33 0 32 3.11 31.11 29.33 46.67 28.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.22 66.22 16.89 34.22 .44 38.67 0 65.33 14.22 66.22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFisicaDeselected);
export default __webpack_public_path__ + "static/media/fisicaDeselected.26085439effe43443f25951711dbcdfe.svg";
export { ForwardRef as ReactComponent };